import type React from 'react';
import { cn } from '@/shared/lib/cn';

interface SectionIconProps {
  icon: React.ReactNode;
  className?: string;
}

export const SectionIcon = ({ icon, className }: SectionIconProps) => {
  return (
    <div
      className={cn(
        'w-[3rem] h-[3rem] bg-section-icon-background border border-section-icon-border rounded-xl flex items-center justify-center',
        className,
      )}
    >
      {icon}
    </div>
  );
};
